import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BubbleMenu, useCurrentEditor } from '@tiptap/react';
import React, { useCallback } from 'react';

import { useStorage } from './useStorage';

const MAX_REPLACEMENTS = 5;

const GrammarCheckerBubble = () => {
  const { editor } = useCurrentEditor();

  const selectedMatch = useStorage(s => s.selectedMatch);

  const acceptSuggestion = useCallback(
    (suggestion: { value: string }) => {
      if (!selectedMatch) return;

      const { from, offset, to } = selectedMatch.range;

      editor?.commands.insertContentAt({ from: from + offset, to: to + offset }, suggestion.value);

      editor?.commands.resetLanguageToolMatch();
    },
    [editor, selectedMatch],
  );

  const ignoreSuggestion = useCallback(() => {
    if (!selectedMatch) return;

    editor?.commands.ignoreLanguageToolSuggestion(selectedMatch);
  }, [editor, selectedMatch]);

  if (!editor) return null;

  return (
    <React.Fragment>
      <BubbleMenu
        editor={editor}
        tippyOptions={{
          placement: 'bottom',
          maxWidth: 200,
          appendTo: 'parent',
        }}
        shouldShow={({ editor }) => !!editor.storage.languagetool.selectedMatch}
        updateDelay={100}
        className="flex flex-col gap-2 bg-card shadow text-card-foreground border border-border rounded-md animate-in slide-in-from-top-2 fade-in-10"
      >
        {!!selectedMatch && (
          <React.Fragment>
            <div className="px-2 pt-2 flex flex-col gap-2">
              <p className="font-bold">{selectedMatch.match.shortMessage}</p>
              <p className="text-xs">{selectedMatch.match.message || 'No Message'}</p>
            </div>

            <ul>
              {selectedMatch.match.replacements
                .slice(0, MAX_REPLACEMENTS)
                .map((replacement: { value: string }, i: number) => (
                  <li key={i + replacement.value}>
                    <button
                      onMouseDown={() => acceptSuggestion(replacement)}
                      className="px-2 text-primary hover:bg-primary hover:text-primary-foreground font-bold text-lg cursor-pointer w-full text-left"
                    >
                      {replacement.value}
                    </button>
                  </li>
                ))}
            </ul>

            <button
              className="p-2 flex items-center gap-2 hover:bg-primary/10"
              onMouseDown={ignoreSuggestion}
            >
              <FontAwesomeIcon icon={faTrash} />
              Dismiss
            </button>
          </React.Fragment>
        )}
      </BubbleMenu>
    </React.Fragment>
  );
};

export default GrammarCheckerBubble;
